import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Modal, ProjectPreview } from 'components';

const GalleryImage = ({ disableModal, image, alt, id }) => {
  return (
    <Modal
      id={id}
      disableModal={disableModal}
      trigger={<Image image={image} alt={alt} />}
      modalContent={<ProjectPreview startPoint={id} />}
    />
  );
};

const Image = styled(GatsbyImage)`
  cursor: pointer;
  width: 100%;
  height: 100%;
  height: auto;
  object-fit: cover;
`;

export default GalleryImage;
